import { FilterCheckbox, MainFilterForm, QuickFilterForm } from './ListTableTypes';

export const isRuledOut = (option: Pick<FilterCheckbox, 'getShouldHide'>, mainFilters: MainFilterForm) =>
    option.getShouldHide?.(mainFilters) === true;

type CheckboxOption = Pick<FilterCheckbox, 'getShouldHide' | 'defaultSelected'> & { isSelected: boolean };

/**
 * Unticks, in place, every option the main filters rule out, in the main and the quick filters alike, and falls a
 * single-choice group left with no answer back on its `defaultSelected` option, as the list applies its filters.
 */
export function dropRuledOutOptions(mainFilters: MainFilterForm, quickFilters: QuickFilterForm) {
    [...Object.values(mainFilters), ...Object.values(quickFilters)].forEach((group) => {
        if (!('filters' in group) || !Array.isArray(group.filters)) return;
        const options = group.filters as CheckboxOption[];
        const ruledOut = options.filter((option) => option.isSelected && isRuledOut(option, mainFilters));
        if (!ruledOut.length) return;
        ruledOut.forEach((option) => (option.isSelected = false));
        const fallback = options.find((option) => option.defaultSelected && !isRuledOut(option, mainFilters));
        if (group.multiple !== true && fallback && !options.some((option) => option.isSelected)) {
            fallback.isSelected = true;
        }
    });
}
